import ChatProvider from '../store/schema/ChatProvider';
import checkForTeams from '../ucwa/chatManager/checkForTeams';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import initializeUcma, { initUcmaPresence } from '../ucma/chatManager/initializeUcma';
import initializeUcwa from '../ucwa/chatManager/initializeUcwa';
import getShellClientData from '../ucwa/chatManager/getShellClientData';
import { getStore } from '../store/chatStore';
import { getUserConfiguration } from 'owa-session-store';
import { isDeepLink } from 'owa-url';
import { isFeatureEnabled } from 'owa-feature-flags';
import { setChatProvider } from '../actions/bootstrapActions';

export default async function initializeSkypeForBusiness() {
    // We use UCMA/UCWA for chat, when
    // 1. Flight for SFB (skype for business) is enabled, and
    // 2. This is not popout winodw, and
    // 3. This is not consumer scenario, and
    // 4. This is not explicit logon, and
    // 5. User settings prefer UCMA than UCWA (can be overridden by flight fwk-skypeBusiness-ucmadebug)
    if (
        !isFeatureEnabled('fwk-skypeBusinessV2') ||
        isDeepLink() ||
        isConsumer() ||
        getUserConfiguration().SessionSettings.IsExplicitLogon
    ) {
        setChatProvider(ChatProvider.Disabled);
        return;
    }

    const clientData = getShellClientData();
    const store = getStore();
    const canUseSWX = isFeatureEnabled('fwk-skypeBusinessV2SWX');

    if (clientData && store.chatProvider == ChatProvider.Unknown) {
        if (isFeatureEnabled('fwk-skypeBusiness-ucmadebug')) {
            setChatProvider(ChatProvider.UCMA);
        } else {
            setChatProvider(ChatProvider.Checking);

            if (canUseSWX) {
                setChatProvider(
                    clientData?.LyncIntegrationDisabled ? ChatProvider.UCMA : ChatProvider.UCWA
                );
            } else if (await checkForTeams(clientData)) {
                setChatProvider(ChatProvider.Teams);
            } else {
                setChatProvider(ChatProvider.UCMA);
            }
        }
    }

    switch (store.chatProvider) {
        case ChatProvider.UCMA:
            initializeUcma();
            break;

        case ChatProvider.UCWA:
            initializeUcwa();
            break;

        case ChatProvider.Teams:
            initUcmaPresence();
            break;
    }
}
